"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftColor = void 0;
function shiftColor(base, change) {
    var colorRegEx = /^\#?[A-Fa-f0-9]{6}$/;
    if (!base || !change) {
        return '#000000';
    }
    if (!base.match(colorRegEx) || !change.match(colorRegEx)) {
        return '#000000';
    }
    // remove '#'s
    base = base.replace(/\#/g, '');
    change = change.replace(/\#/g, '');
    var newColor = '';
    for (var i = 0; i < 3; i++) {
        var basePiece = parseInt(base.substring(i * 2, i * 2 + 2), 16);
        var changePiece = parseInt(change.substring(i * 2, i * 2 + 2), 16);
        var newPiece = void 0;
        newPiece = basePiece + changePiece;
        newPiece = newPiece > 255 ? 255 : newPiece;
        newPiece = newPiece.toString(16);
        newPiece = newPiece.length < 2 ? '0' + newPiece : newPiece;
        newColor += newPiece;
    }
    return "#".concat(newColor);
}
exports.shiftColor = shiftColor;
